<template>
  <div :style="{marginTop:marginTopProps?marginTopProps:'auto',paddingTop:paddingTopProps?paddingTopProps:'auto',background:backgroundProps?backgroundProps:'#ffffff'}" :class="['container-main',sourceForm === SOURCEFORM_TMBD?'tmBd-main':'common-main']" >
    <slot></slot>
  </div>
</template>
<script>
import { getQueryUrl } from "../util/getQueryUrl.js";
import {SOURCEFORM_TMBD} from "../constant/consts.js";
export default {
  props: ['marginTopProps','paddingTopProps','backgroundProps'],
  data() {
    return {
      sourceForm:'h5',
      SOURCEFORM_TMBD
    };
  },
  mounted(){
    const that = this
    that.sourceForm = getQueryUrl("from") || "h5";

  }
};
</script>
<style lang="less" scoped>
.container-main{
  width: 100%;
  height: 100%;
  margin-top: 0px;
}
.common-main{
  margin-top: 44px;
}
.tmBd-main{
  margin-top: 15px;
}

</style>
